import SideBarCarCatalog from 'components/Page/PageSideBar/SideBarCarCatalog/SideBarCarCatalog';
export default SideBarCarCatalog;
